<template>
    <div class="margin_area">
        <p class="tit">
            请选择充值金额
            <van-icon name="cross" @click="close"/>
        </p>
        <margin-recharge/>
    </div>
</template>

<script>
    export default {
        name: 'margin',
        data() {
            return {}
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            close() {
                this.$emit('closeModal')
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
.margin_area {
    padding: 1rem 1.2rem 0;
    .tit {
        display: flex;
        justify-content: space-between;
        color: #000;
        font-size: 1.6rem;
        font-weight: 700;
        .van-icon {
            font-size: 2rem;
            cursor: pointer;
        }
    }
}
</style>